<template>
    <div class="city-map-cta">
        <a href="#">
            <div class="map-wrap" ref="mapElement"></div>
            <googlemaps-map
                ref="map"
                :options="mapOptions"
                :center.sync="center"
                :zoom.sync="zoom"
                class="ais-GeoSearch-map map-wrap"
            ></googlemaps-map>
            <div class='content'>
                <svg class='location-pin'><use xlink:href="#location-pin"></use></svg>
                <span>Browse the Map</span>
                <svg class='large-arrow'><use xlink:href="#large-arrow"></use></svg>
            </div>
        </a>
    </div>
</template>
<script>

import MapsHelpers from '@/mixins/MapsHelpers'

export default {

    mixins:[MapsHelpers],

    props: ['city'],

    data(){
        return {
            mapOptions: null,
            center: {lat: 0, lng: 0},
            zoom: 12,
        }
    },

    created() {
        this.mapOptions = {
            mapTypeControl: false,
            fullscreenControl: false,
            streetViewControl: false,
            styles: this.mapStyles
        }

        if (this.city && this.city.map_lat_override && this.city.map_lng_override) {
            this.center = {
                lat: this.city.map_lat_override,
                lng: this.city.map_lng_override
            }
        }
    },

    mounted() {
        let self = this;
        $('.mob-map-trigger').on('click', function () {
            self.disableScroll()
            $(this).slideUp(function () {
                $('.map-main').addClass('show')
                $('.mob-map-controls').addClass('show')
                $('#mob-map-trigger').addClass('active')
            })
        })
    },

    methods: {

        disableScroll() {
            document.body.style.overflowY = "hidden";
            // window.onscroll = function (event) {
            //     event.preventDefault()
            //     console.log('scrolling')
            //     window.scrollTo(0, 0);
            // };
            // document.body.addEventListener('touchmove', event => {
            //     event.preventDefault();
            // }, false);
        }
    }
}
</script>
